import { render, staticRenderFns } from "./VisualAcuityForm.vue?vue&type=template&id=33ff859e"
import script from "./VisualAcuityForm.vue?vue&type=script&lang=js"
export * from "./VisualAcuityForm.vue?vue&type=script&lang=js"
import style0 from "./VisualAcuityForm.vue?vue&type=style&index=0&id=33ff859e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports